module.exports = __webpack_public_path__ + "static/media/insta-5.56ef0aec.png";